import { render } from "./WorkspaceIncorrectPermissions.vue?vue&type=template&id=53bd2f86&scoped=true&ts=true"
import script from "./WorkspaceIncorrectPermissions.vue?vue&type=script&lang=ts"
export * from "./WorkspaceIncorrectPermissions.vue?vue&type=script&lang=ts"

import "./WorkspaceIncorrectPermissions.vue?vue&type=style&index=0&id=53bd2f86&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53bd2f86"]])

export default __exports__